import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';

import swal, { SweetAlertOptions } from 'sweetalert2';
import { SwalComponent } from '@toverux/ngx-sweetalert2';

import { AlertService, AuthenticationService } from '../_services';
import { Globals } from '../_helpers';
import { HttpHeaders, HttpClient } from '@angular/common/http';


export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}

@Component({
    selector: 'candidate-home',
    templateUrl: './home.component.html',
})

export class HomeComponent implements OnInit {

    @ViewChild('alertBrowser') private alertBrowser: SwalComponent;

    public alertOption: SweetAlertOptions = {};

    usernameFormControl = new FormControl('', [
        Validators.required,
    ]);
    matcher = new MyErrorStateMatcher();

    loading = false;
    submitted = false;
    isErrorLogin = false;
    errorMsg: string;
    returnUrl: string;
    userinfo: any;
    studentid: number = 0;    
    examid: number = 0;      

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private alertService: AlertService,
        private globals: Globals,
        private spinner: NgxSpinnerService,
        private http: HttpClient

    ) { }


    ngOnInit() {
        /* clear loaclStorege */
        localStorage.clear();
        sessionStorage.clear();

        // reset login status
        this.authenticationService.logout();
        this.loading = false;
        this.spinner.hide();       
        this.returnUrl = '/';
    }

/*    ngAfterViewInit() {
        this.detectBrowserSuport();
    }*/


    private detectBrowserSuport() {
        let isSupport = true;
        let video = document.createElement('video');
        if (video.canPlayType('video/ogg; codecs="theora"') == "")
            isSupport = false;

        if (video.canPlayType('video/mp4; codecs="avc1.42E01E"') == "")
            isSupport = false;

        if (video.canPlayType('video/webm; codecs="vp8, vorbis"') == "")
            isSupport = false;

        if (video.canPlayType('video/webm; codecs="vp9"') == "")
            isSupport = false;

        const audio = document.createElement('audio');
        if (audio.canPlayType('audio/mpeg') == "")
            isSupport = false;

        if (audio.canPlayType('audio/wav') == "")
            isSupport = false;

        if (!isSupport) {
            this.alertBrowser.show();
            //alert('Your brawser is unsupported, please update your brawser.');
        }
        else {
            console.log('ok');
        }

    }
    loginpasscode() {
        this.router.navigate(['/login'])
    }
    candidatelogin() {
        this.router.navigate(['/userlogin'])
    }    
    assessorlogin() {
        window.location.href = 'https://assessor.pareekshn.com/login';
    }        
}


